"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgWorld = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_WORLD", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm3.055-2.835c.488-1.154.816-2.588.914-4.165h1.948a6.005 6.005 0 0 1-2.862 4.165Zm-6.11-10.33C4.457 3.989 4.13 5.423 4.031 7H2.083a6.005 6.005 0 0 1 2.862-4.165ZM6.035 7c.11-1.534.465-2.841.925-3.762.279-.558.56-.9.775-1.082a.852.852 0 0 1 .216-.142A.215.215 0 0 1 8 2l.01.001a.215.215 0 0 1 .039.013c.04.016.113.054.216.142.216.182.496.524.775 1.082.46.92.815 2.228.925 3.762h-3.93Zm0 2h3.93c-.11 1.534-.465 2.841-.925 3.762-.279.558-.56.9-.775 1.082a.853.853 0 0 1-.216.143A.21.21 0 0 1 8 14l-.01-.001a.21.21 0 0 1-.039-.013.853.853 0 0 1-.216-.142c-.216-.182-.496-.524-.775-1.082-.46-.92-.815-2.228-.925-3.762ZM4.031 9c.098 1.577.426 3.011.914 4.165A6.005 6.005 0 0 1 2.083 9h1.948Zm7.938-2c-.098-1.577-.426-3.011-.914-4.165A6.005 6.005 0 0 1 13.917 7h-1.948Z" }))); };
exports.default = SvgWorld;
